import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireStorage } from 'angularfire2/storage';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ErrorService } from './error.service';



@Injectable()
export class UploadService {
  uploadPercentObservable: Observable<number>;
  uploadPercentageSubscription$: Subscription;
  uploadPercent = 0;
  
  downloadURLObservable: Observable<string>;
  downloadURLSubscription$: Subscription;



  constructor(private afd: AngularFireDatabase, private afStorage: AngularFireStorage, public errorService: ErrorService) {
  }



  // Uploads file to Firebase storage, and returns the file's access URL
  pushUpload(pageName, upload) {
    // Returns a promise, so we can use .then() when pushUpload is called
    return new Promise( (resolve, reject) => {

      this.uploadPercent = 0;

      // Include the current timeStamp in the file name, so each upload can be uniquely identified - no 1 photo will ever be used in 2 places, can safely delete this file later w/o fear of messing up something else
      const timeStamp = new Date().getTime();
      
      // Upload the file
      const uploadTask = this.afStorage.upload(`${pageName}/${timeStamp}-${upload.file.name}`, upload.file);

      // Observe percentage changes
      this.uploadPercentObservable = uploadTask.percentageChanges();
      this.uploadPercentageSubscription$ = this.uploadPercentObservable.subscribe(
        eachValue => {
          this.uploadPercent = Math.round(eachValue*10) / 10
        },
        err => {
          console.log('uploadPercentageSubscription$ errored out in upload.service.ts, here is the err:')
          console.log(err)
        },
        () => {
          console.log('uploadPercentageSubscription$ completed')
        }
      )

      // Get notified when the download URL is available, return it from the function
      uploadTask.snapshotChanges().pipe( finalize( () => {
        this.downloadURLObservable = this.afStorage.ref(`${pageName}/${timeStamp}-${upload.file.name}`).getDownloadURL()
        this.downloadURLSubscription$ = this.downloadURLObservable.subscribe(
          eachValue => {
            resolve(eachValue)
          },
          err => {
            console.log('downloadURLSubscription$ errored out in upload.service..ts, here is the err:')
            console.log(err)
          },
          () => {
            console.log('downloadURLSubscription$ completed')
          }
        )
      })).subscribe()

    }); // End of returned promise
  } // End of pushUpload() for regular image



  // Delete a file from storage
  deleteUpload(urlToDelete) {
    // Returns a promise, so we can use .then() when deleteUpload is called
    return new Promise( (resolve, reject) => {
      // If there is no URL passed, resolve the promise immediately
      if (urlToDelete === '') {
        resolve()
      } else {
        this.afStorage.refFromURL(urlToDelete).delete().toPromise().then( () => {
          resolve();
        }).catch( err => {
          console.log('Error in content.service.ts in the pushUpload function:');
          console.log(err);
          this.errorService.showErrorMessage('Error deleting file');
          reject(err);
        })
      }
    })
  }



}






  // Delete a file from storage
  // deleteUpload(urlToDelete) {
  //   // Returns a promise, so we can use .then() when deleteUpload is called
  //   return new Promise( (resolve, reject) => {
  //     // If there is no URL passed, resolve the promise immediately
  //     if (urlToDelete === '') {
  //       resolve()
  //     } else {
  //       // Delete the file, then resolve the promise
  //       firebase.storage().refFromURL(urlToDelete).delete().then( () => {
  //         resolve();
  //       }).catch( err => {
  //         console.log('Error in content.service.ts in the pushUpload function:');
  //         console.log(err);
  //         this.errorService.showErrorMessage('Error deleting file');
  //         reject(err);
  //       })
  //     }
  //   })
  // }





















// I'm going to reopen this issue - the .ref method expects a path and fails when given a URL.

// I've found a solution, and I feel this functionality needs to be added to the package. Firebase includes a refFromUrl() method - I think AngularFire2 should too. I've played around inside the AngularFire2 package and I think I've got it working to accept a URL... here is how:

// (All of this is in the angularfire2 -> storage directory)

// Inside storage.js, right below the existing AngularFireStorage.prototype.ref declaration, you need:

//     AngularFireStorage.prototype.refFromURL = function (url) {
//         return createStorageRef(this.storage.refFromURL(url), this.scheduler);
//     };
// Inside storage.d.ts, right below the existing ref(path: string): line, you need:

//     refFromURL(url: string): AngularFireStorageReference;
// Inside storage.js.map, you will need to do some hunting... include this:

//     refFromUrl(url: string) {\n    return createStorageRef(this.storage.refFromUrl(url), this.scheduler);\n  }\n\n
// immediately after ref(path: string) {\n return createStorageRef(this.storage.ref(path), this.scheduler);\n }\n\n and before the upload(path: string, data: any, metada.... really close to the end of the file.

// That adds the ability to delete a file in Firebase Storage when given the URL... this is an example of it in use:

//         this.afStorage.refFromURL(urlToDelete).delete().toPromise().then( () => {
//                  // Successfully deleted
//         }).catch( err => {
//                  // Handle err
//         })
// I'm too inexperienced to know if there are other locations in the code that need updated / tested, and I've never done a pull request before... if this could be included in the next release, that would be amazing.
// (and thanks again for the great package)















  // // Uploads file to Firebase storage, and returns the file's access URL
  // pushUpload(pageName, upload) {
  //   // Returns a promise, so we can use .then() when pushUpload is called
  //   return new Promise( (resolve, reject) => {
  //     // Include the current timeStamp in the file name, so each upload can be uniquely identified - no 1 photo will ever be used in 2 places, can safely delete this file later w/o fear of messing up something else
  //     const timeStamp = new Date().getTime();
  //     // Upload the file
  //     const uploadTask = firebase.storage().ref().child(`${pageName}/${timeStamp}-${upload.file.name}`).put(upload.file);
  //     // Based on how the upload is going, perform the following actions:
  //     uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
  //       (snapshot) => {
  //         // Upload in progress
  //         const snap = snapshot as firebase.storage.UploadTaskSnapshot;
  //         upload.progress = Math.round( (snap.bytesTransferred / snap.totalBytes) * 100);
  //       },
  //       (err) => {
  //         // Upload failed, output error to the console and show a flash error message
  //         console.log('Error in content.service.ts in the pushUpload function:');
  //         console.log(err);
  //         this.errorService.showErrorMessage('Error while uploading file');
  //         reject(err);
  //       },
  //       () => {
  //         // Upload succeeded, pull relevant information out of the returned info from storage
  //         uploadTask.snapshot.ref.getDownloadURL().then( downloadURL => {
  //           resolve(downloadURL);
  //         });
  //       }
  //     ); // End of uploadTask.on()
  //   }); // End of returned promise
  // } // End of pushUpload() for regular image